import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'shared/utils/toast';
import { ticketingService } from '../TicketingService';
import { useTicketColumns } from '../tickets';

export const ToBeApproveTickets = () => {
  const translationPrefix = 'pages.tickets';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const approve = (id: number, old_approvation_status?: boolean | null) => {
    if (old_approvation_status && old_approvation_status === true) {
      toast.warning(t(`${translationPrefix}.already-approved`));
    } else {
      ticketingService.approvedByUser(+id).then(() => {
        toast.success(t(`${translationPrefix}.ticket-approved`));
        datagridRefresh.current();
      });
    }
  };

  const handleDelete = (id: number) => {
    ticketingService.delete(id).then(() => {
      toast.success(t('actions.successfully.deleted'));
      datagridRefresh.current();
    });
  };

  const columns = useTicketColumns({ handleApprovation: true, approve, handleDelete });
  return (
    <TenantPage
      title={t(`${translationPrefix}.to-approve`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={ticketingService}
        getMethod={ticketingService.getToBeApprove}
        disableDelete
        refresh={datagridRefresh}
        initialOptions={{
          pinnedColumns: { left: [], right: [] }
        }}
      />
    </TenantPage>
  );
};

export default ToBeApproveTickets;
